import buildURL from 'build-url';
import Config from '@/config';

const builder = base => (path = '', config = {}) => buildURL(base, {
  path,
  ...config,
});

export const baseURL = () => process.env.BASE_URL || '/';
export const cloudfrontURL = builder(Config.get('CLOUDFRONT_URL'));
export const webSiteURL = builder(Config.get('WEBSITE_URL'));
export const userAccountURL = builder(Config.get('USER_ACCOUNT_URL'));
export const blogURL = builder(Config.get('BLOG_URL'));
